import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const allowedAdminPaths = ["/admin", "/admin/approval", "/admin/approved"];

const AdminProtectedRoute = ({ children }) => {
  const location = useLocation();

  let isAdminLoggedIn = false;

  try {
    const savedAdmin = JSON.parse(localStorage.getItem("adminAuth"));
    isAdminLoggedIn = savedAdmin?.isLoggedIn === true;
  } catch (err) {
    isAdminLoggedIn = false;
  }

  if (!isAdminLoggedIn) {
    return <Navigate to="/admin-login" replace state={{ from: location }} />;
  }

  if (!allowedAdminPaths.includes(location.pathname)) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default AdminProtectedRoute;